var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var LRUCache = /*#__PURE__*/function () {
  "use strict";

  function LRUCache() {
    _classCallCheck(this, LRUCache);

    this.max = 1000;
    this.map = new Map();
  }

  _createClass(LRUCache, [{
    key: "get",
    value: function get(key) {
      var value = this.map.get(key);

      if (value === undefined) {
        return undefined;
      } else {
        // Remove the key from the map and add it to the end
        this.map["delete"](key);
        this.map.set(key, value);
        return value;
      }
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      return this.map["delete"](key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var deleted = this["delete"](key);

      if (!deleted && value !== undefined) {
        // If cache is full, delete the least recently used item
        if (this.map.size >= this.max) {
          var firstKey = this.map.keys().next().value;
          this["delete"](firstKey);
        }

        this.map.set(key, value);
      }

      return this;
    }
  }]);

  return LRUCache;
}();

module.exports = LRUCache;